import { produce } from 'immer'
import { SchemesStore } from './types'
import { Action } from './actions'

export const initialState: SchemesStore = {
  schemes: {},
  activeSchemeId: undefined,
}

export const schemesReducer = (state: SchemesStore, action: Action): SchemesStore =>
  produce(state, (draft) => {
    switch (action.type) {
      case 'ADD_SCHEME':
        draft.schemes[action.payload.schemeId] = action.payload.scheme
        break
      case 'REMOVE_SCHEME':
        delete draft.schemes[action.payload.schemeId]
        if (draft.activeSchemeId === action.payload.schemeId) {
          draft.activeSchemeId = undefined
        }
        break
      case 'UPDATE_SCHEMES_CONTEXT':
        if (draft.schemes[action.payload.schemeId]) {
          draft.schemes[action.payload.schemeId].designPersonalizationContext.designPersonalizationData = action.payload.contextData
          draft.schemes[action.payload.schemeId].designPersonalizationContext.designPersonalizationContextId = action.payload.contextId
        }
        break
      case 'SET_ACTIVE_SCHEME':
        draft.activeSchemeId = action.payload.schemeId
        break
      case 'MARK_SCHEME_UPDATING':
        if (draft.schemes[action.payload.schemeId]) {
          draft.schemes[action.payload.schemeId].isUpdating = true
        }
        break
      case 'UNMARK_SCHEME_UPDATING':
        if (draft.schemes[action.payload.schemeId]) {
          draft.schemes[action.payload.schemeId].isUpdating = false
        }
        break
      default:
        break
    }
  })
